export default {
  items: [
    {
      title: "Anasayfa",
      url: "#/",
      icon: "flaticon-layers",
      role: ["*"]
    },
    {
      title: "Fatura",
      lisance: "Advance",
      url: "#",
      icon: "flaticon-layers",
      children: [
        {
          title: "Fatura Aktarımı",
          url: "#/invoiceUpload",
          icon: "flaticon-layers",
          role: ["*"]
        },
        {
          title: "Fatura Kuyruğu",
          url: "#/invoiceQueue",
          icon: "flaticon-layers",
          role: ["*"]
        },
        {
          title: "İşlenen Faturalar",
          url: "#/invoices",
          icon: "flaticon-layers",
          role: ["*"]
        }
      ]
    },
    {
      title: "Avans",
      lisance: "Advance",
      url: "#",
      icon: "flaticon-layers",
      children: [
        {
          title: "Avans Formu",
          url: "#/Advances",
          icon: "flaticon-layers",
          role: ["*"]
        }
      ]
    },
    {
      title: "Masraf",
      lisance: "Expense",
      url: "#",
      icon: "flaticon-layers",
      children: [
        {
          title: "Masraflar",
          url: "#/expenses",
          icon: "flaticon-layers",
          role: ["*"]
        },
        {
          title: "Masraf Merkezi",
          url: "#/expenseCenters",
          icon: "flaticon-layers",
          role: ["*"]
        },
        {
          title: "Projeler",
          url: "#/projects",
          icon: "flaticon-layers",
          role: ["*"]
        },
        {
          title: "Masraf Tipleri",
          url: "#/expenseTypes",
          icon: "flaticon-layers",
          role: ["*"]
        }
      ]
    },
    {
      title: "Entegrasyonlar",
      url: "#",
      icon: "flaticon-layers",
      children: [
        {
          title: "Entegrasyon",
          url: "#/gateways",
          icon: "flaticon-layers",
          role: ["*"]
        },
        {
          title: "Transfer Ayarları",
          url: "#/transferConfigs",
          icon: "flaticon-layers",
          role: ["*"]
        },
        {
          title: "Transfer Ayarları Geçmişi",
          url: "#/transferConfigHistories",
          icon: "flaticon-layers",
          role: ["*"]
        },
        {
          title: "Transfer Data Geçmişi",
          url: "#/transferDatas",
          icon: "flaticon-layers",
          role: ["*"]
        }
      ]
    },
    {
      title: "Eprocess",
      url: "#",
      icon: "flaticon-layers",
      children: [
        {
          title: "Gib Kullanıcı Sorgulama",
          url: "#/eProcess/",
          icon: "flaticon-layers",
          role: ["*"]
        },
        {
          title: "Doküman İndirme",
          url: "#/eProcess/getDocument",
          icon: "flaticon-layers",
          role: ["*"]
        },
       {
          title: "Doküman Sorgulama",
          url: "#/eProcess/getDocumentStatus",
          icon: "flaticon-layers",
          role: ["*"]
        },
      ]
    },
    {
      title: "Yönetim",
      url: "#",
      icon: "flaticon-layers",
      
      children: [
       
        {
          title: "Parametre",
          url: "#/Parameters",
          icon: "flaticon-layers",
          role: ["*"]
        },
        {
          title: "Kullanıcılar",
          url: "#/Users",
          icon: "flaticon-layers",
          role: ["*"]
        },
        {
          title: "Müşteriler",
          url: "#/Tenants",
          icon: "flaticon-layers",
          role: ["Admin.Admin"]
        },
        {
          title: "Lisanslar",
          url: "#/Licenses",
          icon: "flaticon-layers",
          role: ["Admin.Admin"]
        },
        {
          title: "Lisans Paketleri",
          url: "#/LicenseBundles",
          icon: "flaticon-layers",
          role: ["Admin.Admin"]
        },
        {
          title: "Roller",
          url: "#/Roles",
          icon: "flaticon-layers",
          role: ["*"]
        }
      ]
    },
    {
      title: "Bildirimler",
      url: "#/Notifications",
      icon: "flaticon-layers",
      role: ["*"]
    },
    {
      title: "Onaylar",
      url: "#/Approves",
      icon: "flaticon-layers",
      role: ["*"]
    }
   ]
};
